import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface PatrimonyModal {
	title: string;
	proposalGuaranteeDocument: string;
	indice: number;
	proposalStatus: string;
	comentarioFiador: string;
	isUserOwner: boolean;
}

@Component({
	selector: 'patrimony-modal',
	templateUrl: './patrimony-modal.component.html',
	styleUrls: ['./patrimony-modal.component.scss']
})
export class PatrimonyModalComponent extends DialogComponent<PatrimonyModal, boolean> implements PatrimonyModal {
	title: string;
	proposalGuaranteeDocument: string;
	indice: number;
	proposalStatus: string;
	comentarioFiador: string;
	isUserOwner: boolean;
	
	constructor(dialogService: DialogService) {
		super(dialogService);
	}

	savePotencial(confirm) {
		$("#tempPotencialPatrimonialGrupo").val(Number($("#potencialTotalCalculado").val()));

		if (confirm) {
			this.confirm();
		} else {
			this.close();
		}
	}

	confirm() {
		this.close();
	}
}



// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/limit-flow-proposal/patrimony-modal/patrimony-modal.component.ts